import React from 'react';
import API from "@beardeddevops/react.api";
import Framework from "@beardeddevops/react.framework";
import Financial_Numbers from "components/Collections/Financial_Final_Numbers";
import UserRoles from "constants/UserRoles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import classNames from "classnames";
import Types from "../../../../../constants/Types";
import {Button} from "reactstrap";
import moment from "moment";
import IconButton from "@material-ui/core/IconButton";
import LeftArrowIcon from "@material-ui/icons/ChevronLeft";
import RightArrowIcon from "@material-ui/icons/ChevronRight";
import {Collections} from "../../../../../components";


const breadcrumbsStatic = [{
	name: 'Pay Center Admin',
	url: '/pay_center_admin',
	icon: 'dashboard',
}];

class Financial_Final_Numbers extends Framework.Components.View {

	constructor(props) {
		//super(props, 'entry');
		super(props, 'approvals');
		localStorage.removeItem('table-preferences-Idle_Tasks');
		this.state = {
			location_data: [],
			review_data: [],
			//tab: 'entry',
			tab: 'approvals',
			filterDate: moment().day(0).format('YYYY-MM-DD'),
			submitData: false,
			filterFEs: false
		};
	}

	render() {

		const startDate = this.state.filterDate ? moment(this.state.filterDate) : moment().day(0);
		const endDate = this.state.filterDate ? moment(this.state.filterDate).add(6, 'days') : moment().day(0).add(6, 'days');

		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history} />

				<Tabs value={this.state.tab} onChange={this.handleTabChange} component={'div'}>
					<Tab label="Data Entry" value="entry"/>
					<Tab label="Approve/Reject" value="approvals"/>
				</Tabs>

				{this.state.tab === 'entry' &&
				<div className={classNames({'hidden': this.state.tab !== 'entry'})}>
					<div className="table-bar">
						<div className={"row rbc-toolbar"}>
							<div>
								<IconButton onClick={async () => {
									this.setState({filterDate: moment(this.state.filterDate).subtract(7, 'days').format('YYYY-MM-DD')})
								}}><LeftArrowIcon/></IconButton>
								<button className="rbc-today" type="button" onClick={async () => {
									this.setState({filterDate: moment().day(0).format('YYYY-MM-DD')})
								}} disabled={this.state.filterDate === moment().day(0).format('YYYY-MM-DD')}>This Week
								</button>
								<IconButton disabled={this.state.filterDate === moment().day(0).format('YYYY-MM-DD')} onClick={async () => {
									this.setState({filterDate: moment(this.state.filterDate).add(7, 'days').format('YYYY-MM-DD')})
								}}><RightArrowIcon/></IconButton>
							</div>
							<div style={{marginLeft: 50}}>
								<Button onMouseDown={() => this.setState({filterFEs: true})}>
									Filter To FEs
								</Button>
							</div>
							<div className={"rbc-toolbar-label"}>
								<label>
									{startDate.format('MMMM D') + ' - ' + endDate.format('MMMM D')}
								</label>
							</div>
							<div style={{paddingRight: 10}}>
								<Button onMouseDown={() => this.setState({submitData: true})}>
									Submit
								</Button>
							</div>
						</div>
					</div>
					<Financial_Numbers
						filter_date={this.state.filterDate}
						submit={this.state.submitData}
						filterFEs={this.state.filterFEs}
						toggleSubmit={() => this.setState({submitData: false})}
						toggleFilter={() => this.setState({filterFEs: false})}
					/>
				</div>
				}

				{this.state.tab === 'approvals' &&
					<Collections.Financial_Approvals
						key={this.state.key}
						history={history}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						regions={this.props.regions}
						filter={UserRoles[this.state.tab]}
						allowDone={false}
						handleTabChange={(event, tab, func) => {
							this.handleTabChange(event, tab);
							if(typeof func === 'function') {
								func();
							}
						}}
						user={this.props.rootState.user}
					/>
				}
			</div>


		)
	}
}

export default Framework.Components.withRootState(Financial_Final_Numbers);




